module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CHAP-TITLE"
  }, [_vm._v("Mad Mix")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Add a bow tie to a skull, create a bagful of candy or mix a sunny face with a lightning bolt – who says you can’t!")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-16.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e62534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1-8.vue
// module id = 87
// module chunks = 0